
import ValidateField from '../../hooks/useValid';
import { ValidateName } from '../../constants/ValidateNameConstants';

export default function validation(values) {
  let errors = {};

  errors.paymentDescription = ValidateField(values.paymentDescription, ValidateName?.PAYMENT_TERMS,
    ValidateName?.PAYMENT_TERMS, [ValidateName?.REQUIRED]);

  errors.creditDays = ValidateField(values.creditDays, ValidateName?.CREDIT_DAYS,
    ValidateName?.CREDIT_DAYS, [ValidateName?.REQUIRED, ValidateName?.ISNUMBERONLY]);

  errors.paymentTooltip = ValidateField(values.paymentTooltip, ValidateName?.DESCRIPTION,
    ValidateName?.DESCRIPTION, [ValidateName?.REQUIRED, ValidateName?.MIN_LENGTH]);

  return errors;
}


